/**
 * Dynamic Routed Form Handler
 * Supports multiple forms per page.
 * Upload to: Assets > contact-form-routed.js
 */
(function () {
  function initForm(form) {
    var btn = form.querySelector('[type="submit"]');
    var status = form.querySelector('[class*="__status"]');
    var btnText = btn.querySelector('.contact-routed__btn-text');
    var btnLoad = btn.querySelector('.contact-routed__btn-loading');

    /* Time-trap baseline — when the form became interactive. */
    var loadedAt = Date.now();

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      /* Honeypot — clear autofill before checking */
      var hp = form.querySelector('[name="company_url"]');
      if (hp) hp.value = '';

/* Age check (must be 21+) */
var birthdayInput = form.querySelector('[name="Birthday"]');
if (birthdayInput && birthdayInput.value) {
  var birthDate = new Date(birthdayInput.value);
  var today = new Date();
  var age = today.getFullYear() - birthDate.getFullYear();
  var monthDiff = today.getMonth() - birthDate.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  if (age < 21) {
    var fieldWrap = birthdayInput.closest('.contact-routed__field');
    var existingErr = fieldWrap.querySelector('.contact-routed__field-error');
    if (!existingErr) {
      var errEl = document.createElement('p');
      errEl.className = 'contact-routed__field-error';
      errEl.textContent = 'You must be 21 or older to apply.';
      fieldWrap.appendChild(errEl);
    }
    birthdayInput.style.borderColor = '#c0392b';
    return;
  }
}

      /* File size check (20MB) */
      var fileInputs = form.querySelectorAll('input[type="file"]');
      for (var i = 0; i < fileInputs.length; i++) {
        if (fileInputs[i].files.length > 0 && fileInputs[i].files[0].size > 20 * 1024 * 1024) {
          status.className = 'contact-routed__status contact-routed__status--error';
          status.textContent = 'File is too large. Maximum size is 20MB.';
          status.hidden = false;
          return;
        }
      }

      /* Required checkbox groups — at least one option must be checked */
      var cbGroups = form.querySelectorAll('[data-checkbox-group][data-required]');
      for (var g = 0; g < cbGroups.length; g++) {
        var errEl = cbGroups[g].querySelector('.contact-routed__field-error');
        if (cbGroups[g].querySelectorAll('input[type="checkbox"]:checked').length === 0) {
          if (errEl) {
            errEl.textContent = 'Please select at least one option.';
            errEl.hidden = false;
          }
          return;
        } else if (errEl) {
          errEl.hidden = true;
        }
      }

      /* Required paid checkout dropdown — an option must be chosen */
      var coSelRequired = form.querySelector('.contact-routed__checkout-select[data-required]');
      if (coSelRequired && !coSelRequired.value) {
        var coErrEl = coSelRequired.parentNode.querySelector('.contact-routed__checkout-error');
        if (coErrEl) { coErrEl.textContent = 'Please choose an option.'; coErrEl.hidden = false; }
        coSelRequired.focus();
        return;
      }

      /* Required consent checkbox — must be ticked when marked required */
      var consentRequired = form.querySelector('input[data-required-consent]');
      if (consentRequired && !consentRequired.checked) {
        var row = consentRequired.closest('.contact-routed__row');
        var cErrEl = row ? row.querySelector('.contact-routed__consent-error') : null;
        if (cErrEl) { cErrEl.textContent = 'Please tick this box to continue.'; cErrEl.hidden = false; }
        consentRequired.focus();
        return;
      }

      /* Turnstile — make sure the anti-bot token is present. The widget
         normally fills this automatically; if it hasn't, ask the user to wait. */
      var tsField = form.querySelector('.cf-turnstile');
      if (tsField) {
        var token = form.querySelector('[name="cf-turnstile-response"]');
        if (!token || !token.value) {
          status.className = 'contact-routed__status contact-routed__status--error';
          status.textContent = 'Please complete the verification and try again.';
          status.hidden = false;
          return;
        }
      }

      btn.disabled = true;
      btnText.hidden = true;
      btnLoad.hidden = false;
      status.hidden = true;

      /* Build FormData */
      var formData = new FormData(form);
      formData.delete('company_url');

      /* Add context */
      formData.append('shop', window.Shopify ? Shopify.shop : location.hostname);
      formData.append('page_url', location.href);
      formData.append('submitted_at', new Date().toISOString());
      formData.append('elapsed_ms', String(Date.now() - loadedAt));

      /* Add routing info */
      formData.append('route_field', form.dataset.routeField || '');

      fetch(form.action, {
        method: 'POST',
        body: formData,
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Server responded with ' + res.status);
          return res.json();
        })
        .then(function () {
          /* If a paid checkout dropdown was answered, the application has now been
             saved (to the tracker via the Worker). Add the chosen variant to the
             cart and send the customer straight to checkout to pay, instead of
             showing the thank-you message. */
          var coSel = form.querySelector('.contact-routed__checkout-select');
          var coOpt = coSel && coSel.selectedOptions ? coSel.selectedOptions[0] : null;
          var variantId = coOpt ? coOpt.getAttribute('data-variant-id') : null;
          if (variantId) {
            status.className = 'contact-routed__status contact-routed__status--success';
            status.textContent = 'Application received — taking you to checkout…';
            status.hidden = false;
            var goCheckout = function () {
              fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
              }).then(function (r) {
                if (!r.ok) throw new Error('add failed');
                window.location.href = '/checkout';
              }).catch(function () {
                status.className = 'contact-routed__status contact-routed__status--error';
                status.textContent = 'Your application was saved, but we couldn\'t start checkout. Please try again or contact us.';
              });
            };
            if (coSel.getAttribute('data-clear') === 'true') {
              fetch('/cart/clear.js', { method: 'POST' }).then(goCheckout).catch(goCheckout);
            } else {
              goCheckout();
            }
            return; /* redirecting — skip the normal thank-you + reset */
          }

          var msg = form.closest('.contact-routed');
          var successText = 'Thanks! We\'ll be in touch soon.';

          /* Try to get custom success message from section settings */
          if (msg) {
            var customMsg = msg.querySelector('[data-success-message]');
            if (customMsg) successText = customMsg.dataset.successMessage;
          }

          status.className = 'contact-routed__status contact-routed__status--success';
          status.textContent = successText;
          status.hidden = false;
          form.reset();
        })
        .catch(function () {
          status.className = 'contact-routed__status contact-routed__status--error';
          status.textContent = 'Something went wrong. Please try again or email us directly.';
          status.hidden = false;
        })
        .finally(function () {
          btn.disabled = false;
          btnText.hidden = false;
          btnLoad.hidden = true;
          /* Turnstile tokens are single-use — reset so the next submit gets a fresh one. */
          if (window.turnstile && tsField) {
            try { window.turnstile.reset(tsField); } catch (e) {}
          }
          loadedAt = Date.now();
        });
    });

    console.log('[ContactFormRouted] Handler attached to', form.id || 'form');
  }

  function init() {
    var forms = document.querySelectorAll('.js-routed-form');
    for (var i = 0; i < forms.length; i++) {
      initForm(forms[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
